import { useContext, useEffect } from 'react';
import VideoPlayer from 'react-video-js-player';
import { StoreContext } from './StoreProvider';

const Video = ({ onVideoReady, onVideoPlay, onVideoPause, onVideoTimeUpdate, onVideoEnd }) => {
    const { customerData, hideControls } = useContext(StoreContext);
    const { theVideoGramStore } = customerData;
    const videoReadyToRender = hideControls.length;
    const el = document.querySelector('video');

    useEffect(() => {
        if (!el) {
            return;
        }
        el.setAttribute('playsinline', 'true');
    }, [el]);

    if (!videoReadyToRender) {
        return null;
    }

    return (
        <VideoPlayer
            autoplay={true}
            preload="auto"
            controls={true}
            src={theVideoGramStore.video_uri}
            poster={theVideoGramStore.thumb_uri}
            hideControls={hideControls}
            width="720"
            height="420"
            onReady={onVideoReady}
            onPlay={onVideoPlay}
            onPause={onVideoPause}
            onTimeUpdate={onVideoTimeUpdate}
            onEnd={onVideoEnd}
        />
    )
};

export default Video;
